<template>
<!-- <div style="width: 100%;text-align: center;"> -->
    <!-- <i class="fas fa-circle" v-if="params.value !== '0'" :class="pdrClass"></i>
    <span v-if="params.value !== 0">{{ pdrStatus }}</span> -->
    <!-- <span v-on:click="openModalGed" :class="{ padding: this.value == '' }" style="margin-right: 40%;"><i class="fasC fas fa-link" :title="$lang.PCI.Candidate.Datatable.Attachment"></i></span>

    <i v-on:click="downloadFile" class="fasC fas fa-cloud-download-alt" v-if="value !== undefined && value !== ''"></i> -->

    <!-- Modal ZDOCS -->
    <b-modal
            hide-footer
            hide-header
            centered
            size="xl"
            ref="gedModal"
            id="gedModal"
            static
            @hide="onHide"
            :dialog-class="startupFolderId ? '' : 'zdocs-picker-dialog'"
            :no-close-on-backdrop="true"
            >
            <div class="container-modal-rest"
                 :style="{ height: startupFolderId ? 'calc(100vh - 90px)' : 'calc(100vh - 130px)', display: 'flex', flexDirection: 'column' }">
                <div class="close-modal text-right"><i @click="closeModalGed" class="fas fa-times-circle pointer" style="font-size: 1rem;"></i></div>

                <div class="message text-center" v-if="!this.startupFolderId"><h5 class="mb-2">Escolha uma pasta</h5></div>

                <div class="zdocs-frame-container" style="flex: 1 1 auto; min-height: 0;">
                    <iframe v-if="zdocsUrl"
                            :key="openSeq"
                            :src="zdocsUrl"
                            title="ZDocs"
                            style="width: 100%; height: 100%; border: 0;"
                            allow="clipboard-read; clipboard-write"></iframe>
                    <div v-else class="text-center text-muted p-4">ZDocs não configurado neste ambiente.</div>
                </div>

                <div class="container-buttons text-right mt-2" v-show="!this.startupFolderId">
                    <b-button variant="primary" @click="folderSelected" :disabled="!currentFolder">Selecionar</b-button>
                </div>
            </div>
    </b-modal>

    <!-- Modal ZDOCS -->

<!-- </div> -->
</template>

<script>
import FileSelection from './fileselection.js'
export default FileSelection
</script>

<style>
/* Picker de vincular pasta: largura confortável, centralizado, sem cortar conteúdo. */
.modal-dialog.zdocs-picker-dialog {
  max-width: 720px !important;
  width: 720px !important;
  margin-left: auto !important;
  margin-right: auto !important;
}
.zdocs-picker-dialog .modal-body {
  padding: 0.5rem !important;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/documents/components/folderselection/fileselection.vue